import { formatDateList } from '../util/date/date-list'
import { loadImage } from '../util/image'

export default class {
  public id
  public moTa
  public noiDung
  public hinhThumbnail
  public hinhFull
  public tieuDe
  public tenDanhMuc
  public timePublish
  public url
  public danhMuc
  public danhMucTen
  public danhMucTenKhongDau

  constructor(options) {
    this.id = options.tin_tuc_id || null
    this.moTa = options.mo_ta || ''
    this.noiDung = options.noi_dung || ''
    this.hinhThumbnail = options.hinh_thumbnail
      ? loadImage(options.hinh_thumbnail)
      : ''
    this.hinhFull = options.hinhFull || ''
    this.tieuDe = options.tieu_de || ''
    this.tenDanhMuc = options.ten_danh_muc || ''
    this.timePublish = options.time_publish
      ? formatDateList(new Date(options.time_publish))
      : ''
    this.url = options.url || ''
    this.danhMucTen = options.danh_muc_ten || ''
    this.danhMucTenKhongDau = options.danh_muc_ten_khong_dau || ''
  }
}
